import { create } from "zustand";
import Cookies from "js-cookie";

type CountryStore = {
    country: string;
    setCountryStore: (country: string) => void;
};

export const useCountryStore = create<CountryStore>((set) => ({
    country: Cookies.get("country") || "uae",
    setCountryStore: (country: string) => {
        Cookies.set("country", country);
        set({ country });
    },
}));
